import React, { Component } from "react"
import { inject, observer } from "mobx-react"
import styled from "styled-components"

// import Input from '~/components/Form/LandingInput'
import Spacer from "~/components/Spacer"
import FormError from "~/components/Form/ErrorText"
import PhoneInput from "~/components/Form/PhoneInput"
import withTranslations from "~/components/_hocs/withTranslations"
import InputTitle from "./InputTitle"
import constants from "~/style/constants"
import * as PhoneNumberTools from "~/utilities/phoneNumber"
import * as StringTools from "~/utilities/string"

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => (props.$compact ? "10px" : "0")};
`

@inject((all) => ({
  validateDisplayMessage: all.store.trafficLookup.validateDisplayMessage,
  phoneNumber: all.store.trafficLookup.phoneNumber,
  changeKey: all.store.trafficLookup.changeKey,
}))
@observer
class PhoneNumberInput extends Component {
  handleChange = (e) => {
    const rawInput = e.target.value
    const digitInput = StringTools.removeNonDigits(rawInput)
    this.props.changeKey("phoneNumber", digitInput)
  }

  render() {
    const phoneNumberErrorHandler = this.props.validateDisplayMessage(
      "phoneNumber"
    )
    const compact = this.props.compact
    return (
      <Wrap $compact={compact}>
        <InputTitle htmlFor="lookup-phone">
          {this.props.translate("label")}
          {!compact && <Spacer direction="width" mobile={11} desktop={11} />}
        </InputTitle>
        {!compact && <Spacer desktop={16} mobile={4} />}
        <PhoneInput
          id="lookup-phone"
          placeholder={this.props.translate("placeholder")}
          onChange={this.handleChange}
          value={PhoneNumberTools.AsYouTypeFormatter(this.props.phoneNumber)}
          altBorderColor={constants.colors.ui.borderGray}
          height="70px"
          boxShadow
          avenirNextRegular
          error={phoneNumberErrorHandler}
          maxWidth="364px"
          maxLength={14}
        />
        <FormError error={phoneNumberErrorHandler} />
      </Wrap>
    )
  }
}

export default withTranslations(PhoneNumberInput, "form.general.phoneNumber")
